module.exports = "<a href class=holding-dashboard-hero-actions-tabs-item> <span class=holding-dashboard-hero-actions-tabs-item__label ng-class=\"{\n      'desktop-only desktop-only--xs': mobileLabel\n    }\" ng-bind=label> </span> <span class=\"holding-dashboard-hero-actions-tabs-item__label mobile-only mobile-only--xs\" ng-if=mobileLabel ng-bind=mobileLabel> </span> </a> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/directives/dashboard-hero-actions-tabs-item/dashboard-hero-actions-tabs-item.html
// module id = 847
// module chunks = 0